import React, { useEffect, useRef, useState } from "react";
// import Logo from "../Assets/Images/logo.svg";
import { Link, NavLink, useNavigate } from "react-router-dom";
import svg from "../Assets/svg";
import { useDispatch, useSelector } from "react-redux";
import { LogoutAPI } from "../Redux/auth";
import { Table, Tooltip } from "antd";
import { GetNavbarCounts } from "../Admin/Redux/challenges";

export const NavigationBar = ({ navigationData }) => {
  const {
    pendingChallenges,
    ongoingChallenges,
    quiz,
    questionBank,
    inactiveCount,
  } = useSelector((state) => state.challengeStats);
  // const [challengeCounts, setChallengeCounts] = useState({
  //   pendingChallenges: 0,
  //   ongoingChallenges: 0,
  // });

  const dynamicNavigationData = [
    {
      id: 1,
      path: "dashboard",
      label: "Dashboard",
      image: svg?.dashboard,
    },
    {
      id: 2,
      path: "users",
      label: "Users",
      image: svg?.users,
    },
    {
      id: 3,
      path: "retrospection",
      label: "Introspection",
      image: svg?.introspection,
    },
    {
      id: 8,
      path: "quests/pending",
      label: (
        <>
          Pending Quests
          {pendingChallenges > 0 && ` (${pendingChallenges})`}
        </>
      ),
      image: svg?.challenge,
    },
    {
      id: 9,
      path: "quests/ongoing",
      label: (
        <>
          Upcoming / Ongoing <br />
          Quests
          {ongoingChallenges > 0 && ` (${ongoingChallenges})`}
        </>
      ),
      image: svg?.challenge,
    },
    {
      id: 12,
      path: "quests/other",
      label: (
        <>
          Completed / Inactive <br />
          Quests
          {inactiveCount > 0 && ` (${inactiveCount})`}
        </>
      ),
      image: svg?.challenge,
    },
    {
      id: 11,
      path: "quizzes",
      label: quiz > 0 ? `Quizzes (${quiz})` : "Quizzes",
      image: svg?.quizIcon,
    },
    {
      id: 10,
      path: "question-bank",
      label:
        questionBank > 0 ? `Question Bank (${questionBank})` : "Question Bank",
      image: svg?.questionBank,
    },
    {
      id: 4,
      path: "static-pages",
      label: "Static Pages",
      image: svg?.staticPage,
    },
    {
      id: 5,
      path: "subscription-history",
      label: "Subscriptions",
      image: svg?.subscription,
    },
    {
      id: 6,
      path: "quote",
      label: "Quotes",
      image: svg?.quoteLogo,
    },
    {
      id: 10,
      path: "banner-library",
      label: "Quest Banner Library",
      image: svg?.bannerLibrary,
    },
    {
      id: 7,
      path: "api-history",
      label: "API calls History",
      image: svg?.apiHistory,
    },
  ];

  const [toggleActive, setToggleActive] = useState(true);
  const [accountClass, setAccountClass] = useState(true);

  const { user } = useSelector((state) => state.auth);

  const dropdownRef = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const fetchNavigationBarCounts = async () => {
    try {
      await dispatch(GetNavbarCounts());
    } catch (error) {
      console.error("Failed to fetch navigation bar counts:", error);
    }
  };

  useEffect(() => {
    fetchNavigationBarCounts();
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleClickOutside = (e) => {
    if (
      dropdownRef?.current !== undefined &&
      !dropdownRef?.current?.contains(e?.target)
    )
      setAccountClass(true);
  };

  const dropDownHandler = (path) => (e) => {
    e.preventDefault();
    navigate(path);
    setAccountClass(true);
  };

  const logoutHandler = (path) => (e) => {
    const token = localStorage.getItem("token");
    dispatch(LogoutAPI(token, navigate));
  };
  return (
    <div className="NavigationBar d-flex flex-column h-100">
      {/* Logo */}
      <div className="py-3 px-4">
        <div className="logo_bg rounded-4 text-center">
          {/* <img src={Logo} width={39} height={36} alt="Logo" /> */}
          <span className="NavLogo">{svg?.navLogo}</span>
        </div>
      </div>
      {/* Logo */}
      {/* Navbar Menu  */}
      <div className="list-unstyled w-100 h-100 m-0 flex-fill overflow-y-auto customScroll">
        {dynamicNavigationData?.map((ele, index) => {
          return (
            <NavigationLink
              id={ele?.id}
              path={ele.path}
              label={ele.label}
              icon={ele.image}
              key={index}
            />
          );
        })}
      </div>
      {/* Navbar Menu  */}
      {/* Sidebar Footer  */}
      <div
        ref={dropdownRef}
        className={`headerAccount ${
          accountClass ? "" : "is-active"
        } position-relative`}
      >
        <div
          className="card sidebar_footer border-0 rounded-4"
          onClick={(e) => setAccountClass(!accountClass)}
        >
          <div className="card-body">
            <div className="d-flex align-items-center text-decoration-none text-white">
              <svg
                width={46}
                height={46}
                className="pro_svg"
                viewBox="0 0 46 46"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx={23} cy={23} r={23} fill="#E1FCDB" />
                <path
                  d="M30.0711 25.9289C28.9819 24.8398 27.6855 24.0335 26.2711 23.5454C27.786 22.502 28.7812 20.7558 28.7812 18.7812C28.7812 15.5935 26.1878 13 23 13C19.8122 13 17.2188 15.5935 17.2188 18.7812C17.2188 20.7558 18.214 22.502 19.729 23.5454C18.3145 24.0335 17.0181 24.8398 15.9289 25.9289C14.0402 27.8177 13 30.3289 13 33H14.5625C14.5625 28.3475 18.3475 24.5625 23 24.5625C27.6525 24.5625 31.4375 28.3475 31.4375 33H33C33 30.3289 31.9598 27.8177 30.0711 25.9289ZM23 23C20.6738 23 18.7812 21.1075 18.7812 18.7812C18.7812 16.455 20.6738 14.5625 23 14.5625C25.3262 14.5625 27.2188 16.455 27.2188 18.7812C27.2188 21.1075 25.3262 23 23 23Z"
                  fill="black"
                />
              </svg>
              <div className="d-flex justify-content-between align-items-center w-100 text-truncate">
                <div className="w-100 text-truncate pe-2">
                  <Tooltip placement="bottom" title={user?.name}>
                    <h3 className="fs-18  mb-0 fw-bold ff text-truncate">
                      {user?.name}
                    </h3>
                  </Tooltip>
                  <Tooltip placement="bottom" title={user?.email}>
                    <p className="fs-14 ff mb-0 text-truncate">{user?.email}</p>
                  </Tooltip>
                </div>
                <span>{svg?.upArrow}</span>
              </div>
            </div>
          </div>
        </div>
        <ul className="m-0 p-0 px-3 py-3 border-n list">
          <DropDownListItem
            label={"Profile"}
            icon={svg?.myProfileIcon}
            clickHandler={dropDownHandler(`/admin/profile`)}
            alt={"My Profile"}
          />
          <DropDownListItem
            label={"Change Password"}
            icon={svg?.changePassword}
            clickHandler={dropDownHandler(`/admin/change-password`)}
            alt={"My Profile"}
          />
          <DropDownListItem
            label={"Logout"}
            icon={svg?.logout}
            clickHandler={logoutHandler(`/auth/login`)}
            alt={"My Profile"}
          />
        </ul>
      </div>

      {/* Sidebar Footer  */}
    </div>
  );
};

export const NavigationLink = ({ path, label, icon }) => {
  return (
    <NavLink
      to={path}
      className="sidebar_link position-relative text-decoration-none fw-bold ff f18 d-flex align-items-center"
    >
      <div className="NavIconBG">{icon}</div>
      <div className="labelContainer ms-2 ff_md f16">
        <span className="ff_md f16">{label}</span>
      </div>
    </NavLink>
  );
};

export const StatCard = ({ label, icon, data }) => {
  return (
    <div className="col-xl-3 col-6">
      <div className="card dashboard_card rounded-3 border-0 h-100 ">
        <div className="card-body">
          <div className="d-flex fs-18 dash_card_title fw-bold ff mb-3 align-items-center">
            {icon && <img src={icon} className="img-fluid" alt="icon" />}
            <label className="ms-2 ff_bd">{label}</label>
          </div>
          <h3 className="title-color fs-42 mb-0 fw-bold ff lh-1">{data}</h3>
        </div>
      </div>
    </div>
  );
};

function roundTo(value, decimals) {
  return Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
}

export const InfoCard = ({
  title,
  data,
  data2,
  icon,
  color,
  smallContainer,
}) => {
  return (
    <div className="col InfoCard">
      <div
        className={`card dashboard_card dc_common ee_dash_card overflow-hidden rounded-3 border-0 h-100 position-relative ${
          (title === "Energy Exercise" && "c-skyHover") ||
          (title === "Maha Mudra" && "c-parrotHover") ||
          (title === "Chant" && "c-peachHover") ||
          (title === "Hong Sau" && "c-pinkHover") ||
          (title === "Aum" && "c-lightDesertHover") ||
          (title === "Kriya and Silence" && "c-desertHover") ||
          (title === "Kriya Count" && "c-blackHover") ||
          (title === "Read Good Book" && "c-lightPinkHover") ||
          (title === "Read SRF Lesson" && "c-lightPeachHover") ||
          (title === "Gratitude" && "c-lightPurpleHover") ||
          (title === "Serve" && "c-darkSkyHover") ||
          (title === "Physical Exercise" && "c-skySecondaryHover")
        }`}
        id="INFO_CARD"
      >
        <div className="card-body">
          <div className="d-flex fs-18 dash_card_title fw-bold ff mb-3 align-items-center gap-2">
            <span>{icon}</span>
            <label className={`labelContainer ${color}`}>{title}</label>
          </div>
          <h3 className="title-color fs-42 mb-0 fw-bold ff lh-1">
            {data ? roundTo(data, 2) : ""}
          </h3>
          <p className="mb-0 fs-6 txt-green infoCardData">{data2}</p>
        </div>
        <div className="position-absolute end-0 bottom-0">{smallContainer}</div>
      </div>
    </div>
  );
};

export const SearchBar = ({
  className,
  value,
  setValue,
  placeholder,
  searchHandler,
  inputClass,
  clearData,
  isLarge = false,
}) => {
  return (
    <div
      className={`adminSearchBar ${
        isLarge ? "" : "adminSearchBarWidth"
      }  ${className} position-relative border-25`}
    >
      <span className="searchIcon">{svg?.search}</span>
      {value?.length > 0 && (
        <span className="clearIcon" onClick={clearData}>
          {svg?.searchClear}
        </span>
      )}
      <input
        type="text"
        className={`searchInput form-control form-control-lg focus-border ${inputClass}`}
        name="searchBar"
        value={value}
        placeholder={placeholder}
        onChange={searchHandler}
      />
    </div>
  );
};

export const UserDetailsCard = ({ icon, label, value, nameOfClass }) => {
  return (
    <div className={nameOfClass}>
      <div className="mb-1 d-flex align-items-center ">
        {icon && <span>{icon}</span>}
        <label className="fs-16 ff fw-normal ms-2 pt-1 txt-green">
          {label}
        </label>
      </div>
      <p className="fw-semibold ff ff_md f16">{value}</p>
    </div>
  );
};

export const Button = ({ text, clickHandler, nameOfClass }) => {
  return (
    <button
      className={`c-green ${nameOfClass} border-25 cursor-pointer`}
      onClick={() => {
        clickHandler();
      }}
    >
      <p className="text-center ff ff_bd f16 py-2 text-white mb-0">{text}</p>
    </button>
  );
};

export const DropDownListItem = ({ clickHandler, icon, alt, label }) => (
  <li className="list-unstyled d-flex align-items-center">
    <NavLink className="text-decoration-none ff_md f14" onClick={clickHandler}>
      <span className="ms-2 d-flex">
        <span>{icon}</span>
        <p className="m-0 ms-2 ff ff_rg f18">{label}</p>
      </span>
    </NavLink>
  </li>
);

export const RoutineCard = ({
  data,
  energyExerciseActivityId,
  mahaMudraActivityId,
  chantActivityId,
  hongSauActivityId,
  aumActivityId,
  kriyaActivityId,
  kriyaCountActivityId,
  readGoodActivityId,
  readSRFActivityId,
  physicalActivityId,
}) => {
  const navigate = useNavigate();
  return (
    <>
      {data?.map((ele, index) => {
        return (
          <div className="col" key={index}>
            <Link
              className="card retrospection_card text-decoration-none ee_data overflow-hidden rounded-3 border-0 h-100 text-center"
              onClick={(e) => {
                e.preventDefault();
                if (ele?.title === "Energy Exercise") {
                  navigate(
                    `/admin/retrospection/exercise-details/${energyExerciseActivityId}`
                  );
                }
                if (ele?.title === "Maha Mudra") {
                  navigate(
                    `/admin/retrospection/mahaMudra-details/${mahaMudraActivityId}`
                  );
                }
                // if (ele?.title === "Chant") {
                //   navigate(`/admin/retrospection/chant-details/${chantActivityId}`);
                // }
                if (ele?.title === "Hong Sau") {
                  navigate(
                    `/admin/retrospection/hongSau-details/${hongSauActivityId}`
                  );
                }
                if (ele?.title === "Aum") {
                  navigate(`/admin/retrospection/aum-details/${aumActivityId}`);
                }
                if (ele?.title === "Kriya and Silence") {
                  if (kriyaActivityId)
                    navigate(
                      `/admin/retrospection/kriya-details/${kriyaActivityId}`
                    );
                }
                if (ele?.title === "Kriya Count") {
                  if (kriyaCountActivityId)
                    navigate(
                      `/admin/retrospection/kriyaCount-details/${kriyaCountActivityId}`
                    );
                }
                if (ele?.title === "Read Good Book") {
                  navigate(
                    `/admin/retrospection/read-good-details/${readGoodActivityId}`
                  );
                }
                if (ele?.title === "Read SRF Lesson") {
                  navigate(
                    `/admin/retrospection/read-srf-details/${readSRFActivityId}`
                  );
                }
                if (ele?.title === "Read SRF Lesson") {
                  navigate(
                    `/admin/retrospection/read-srf-details/${readSRFActivityId}`
                  );
                }
                if (ele?.title === "Physical Exercise") {
                  navigate(
                    `/admin/retrospection/physical-exercise-details/${physicalActivityId}`
                  );
                }
              }}
            >
              <div className="card-body">
                <div className="d-flex flex-column justify-content-center align-items-center fs-22 dash_card_title fw-bold ff mb-2">
                  {ele?.svg}
                  <label className="fs-22 ff txt-green">{ele?.title}</label>
                </div>
                <div className="row gx-1">
                  <div className="col-6">
                    <div className={`border rounded-3 p-2 ${ele?.borderColor}`}>
                      <h3
                        className={`title-color fs-4 mb-1 fw-bold ff lh-1 ${ele?.textColor}`}
                      >
                        {ele?.totalHours}
                      </h3>
                      <p className="mb-0 title-color fs-6 lh-1">
                        {ele?.title === "Kriya Count" ? "Count" : "Hours"}
                      </p>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className={`border rounded-3 p-2 ${ele?.borderColor}`}>
                      <h3
                        className={`title-color fs-4 mb-1 fw-bold ff lh-1 ${ele?.textColor}`}
                      >
                        {ele?.totalUsers}
                      </h3>
                      <p className="mb-0 title-color fs-6 ff lh-1">User</p>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        );
      })}
    </>
  );
};

export const RoutineCard2 = ({ data }) => {
  return (
    <>
      {data?.map((ele, index) => {
        return (
          <div className="col" key={index}>
            <Link className="card retrospection_card text-decoration-none ee_data overflow-hidden rounded-3 border-0 h-100 text-center">
              <div className="card-body">
                <div className="d-flex flex-column justify-content-center align-items-center fs-22 dash_card_title fw-bold ff mb-2">
                  {ele?.svg}
                  <label className="fs-22 ff txt-green">{ele?.title}</label>
                </div>
                <div className="row gx-1">
                  <div className="col-6">
                    <div className={`border rounded-3 p-2 ${ele?.borderColor}`}>
                      <h3
                        className={`title-color fs-4 mb-1 fw-bold ff lh-1 ${ele?.textColor}`}
                      >
                        {ele?.totalHours}
                      </h3>
                      <p className="mb-0 title-color fs-6 lh-1">
                        {ele?.title === "Kriya Count" ||
                        ele?.title === "Gratitude" ||
                        ele?.title === "Serve"
                          ? "Count"
                          : "Hours"}
                      </p>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className={`border rounded-3 p-2 ${ele?.borderColor}`}>
                      <h3
                        className={`title-color fs-4 mb-1 fw-bold ff lh-1 ${ele?.textColor}`}
                      >
                        {ele?.totalUsers}
                      </h3>
                      <p className="mb-0 title-color fs-6 ff lh-1">User</p>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        );
      })}
    </>
  );
};

export const EnergyExerciseCard = ({ title, description }) => {
  return (
    <div className="col-xl-3 col-6">
      <div className="card dashboard_card rounded-3 border-0 h-100">
        <div className="card-body text-center">
          <p className="fs-4 fw-bold ff mb-0 txt-green">{title}</p>
          <p className="mb-0 fs-34 ff txt-blackSm">{description}</p>
        </div>
      </div>
    </div>
  );
};

export const GoBack = () => {
  const navigate = useNavigate();
  return (
    <Link
      className="ack_link mb-md-4 mb-2 d-inline-flex align-items-center fw-bold ff fs-6 text-decoration-none txt-orange cursor-pointer gap-2"
      onClick={(e) => {
        e.preventDefault();
        navigate(-1);
      }}
    >
      <span>{svg?.goBack}</span>
      {"Back"}
    </Link>
  );
};

export const ToggleButton = ({
  data,
  nameOfClassToggle,
  toggleClass,
  isActive,
  nameOfRef,
}) => {
  return (
    <div className={`ToggleButton ${nameOfClassToggle}`}>
      <button onClick={toggleClass}>
        <svg
          width={4}
          height={18}
          viewBox="0 0 4 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.125 9C0.125 10.0338 0.96625 10.875 2 10.875C3.03375 10.875 3.875 10.0338 3.875 9C3.875 7.96625 3.03375 7.125 2 7.125C0.96625 7.125 0.125 7.96625 0.125 9ZM0.125 15.25C0.125 16.2838 0.96625 17.125 2 17.125C3.03375 17.125 3.875 16.2838 3.875 15.25C3.875 14.2162 3.03375 13.375 2 13.375C0.96625 13.375 0.125 14.2162 0.125 15.25ZM0.125 2.75C0.125 3.78375 0.96625 4.625 2 4.625C3.03375 4.625 3.875 3.78375 3.875 2.75C3.875 1.71625 3.03375 0.875 2 0.875C0.96625 0.875 0.125 1.71625 0.125 2.75Z"
            fill="white"
          />
        </svg>
      </button>
      <div
        ref={nameOfRef}
        className={`ToggleBGlist ${isActive ? "not-active" : "is-active"}`}
      >
        <ul className="px-3 py-2 border-n">
          {data?.map((ele, index) => {
            return (
              <li
                className="list-unstyled d-flex flex-row"
                onClick={ele?.handle}
                key={index}
              >
                <span className="me-2 align-self-start">
                  {svg?.deleteSmall}
                </span>
                {ele?.name}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export const CustomPagination = ({
  pageId,
  countCalculation,
  setPageId,
  className,
  pageCount,
  listCount,
  limit,
  deletedText,
  onDeleteClick,
}) => {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [pageId]);

  // Handler
  const nextPageHandler = () => {
    if (countCalculation > pageId) setPageId(pageId + 1);
  };

  const prevPageHandler = () => {
    if (pageId > 0) setPageId(pageId - 1);
  };

  return (
    <div
      className={`${className} d-flex align-items-center justify-content-between`}
    >
      <div className="">
        {countCalculation === 0
          ? "0 out of 0"
          : `${(pageId - 1) * limit + 1} - ${
              limit * pageId > countCalculation
                ? countCalculation
                : limit * pageId
            } out of ${countCalculation}`}
      </div>
      {deletedText?.trim()?.length > 0 && (
        <div
          className="text-danger ff text-decoration-underline fs-6 cursor-pointer"
          onClick={() => {
            if (onDeleteClick) onDeleteClick();
          }}
        >
          {deletedText}
        </div>
      )}
      <nav>
        <ul className="pagination mb-0 gap-2">
          <li className={`page-item ${pageId === 1 ? "disabled" : ""}`}>
            <button
              className="page-link f14 txt-grey border-0"
              onClick={prevPageHandler}
              disabled={pageId === 1}
            >
              {"Prev"}
            </button>
          </li>
          <li className="page-item">
            <button className="page-link f14 c-error txt-white currentpage c-orange border-0">
              {prefixZero(pageId)}
            </button>
          </li>
          <li
            className={`page-item ${
              pageId === pageCount || limit * pageId >= countCalculation
                ? "disabled"
                : ""
            }`}
          >
            <button
              className="page-link f14 txt-grey border-0"
              onClick={nextPageHandler}
              disabled={limit * pageId >= countCalculation}
            >
              {"Next"}
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export function prefixZero(e) {
  return Number(e) < 10 ? `${e}` : String(e);
}

// If Found No Data Then Use This Component
export const NoData = ({ className, message }) => {
  return (
    <div className={`${className ? className : ""} text-center`}>
      <div>
        <span className="noData">{svg?.noData}</span>
        <p className="f24 txt-dark fw-medium mt-3">{message}</p>
      </div>
    </div>
  );
};

export const RenderTable = ({ data, title }) => {
  return (
    <div className="mt-2">
      <Table
        className="modalAntdTable antdThemeTable"
        dataSource={data}
        scroll={{ x: true }}
        columns={[
          {
            title: "author",
            dataIndex: "author",
            key: "author",
          },
          {
            title: "Quote",
            dataIndex: "quote",
            key: "quote",
            width: "",
            render: (_, data) => {
              return data?.quote;
              // <Tooltip title={data?.quote}>
              // 	<span>{data?.quote > 20 ? `${data?.quote.substring(0, 20)}...` : data?.quote}</span>
              // </Tooltip>;
            },
          },
        ]}
      />
    </div>
  );
};

// Radio Button Select Any One
export const RadioButtonSelectAnyOne = ({
  data,
  className,
  name,
  setValue,
  value,
  children,
  setPageId,
  setSearch,
}) => {
  return (
    <>
      {data?.map((ele, index) => (
        <>
          <label
            htmlFor={ele?.value}
            className={`RadioButtonSelectAnyOne ${className} d-flex align-items-center justify-content-center f14 ff_md text-uppercase border-s px-3 cursor-pointer min-fit-content ${
              value === ele?.value
                ? "c-error txt-white isActive"
                : " isNotActive border-1 c-white b-error txt-error"
            } ${ele?.length === 0 ? `zeroAssign` : ``}`}
            key={index}
          >
            <input
              type={"radio"}
              className="form-check-input"
              id={ele?.value}
              value={ele?.value}
              name={name}
              onChange={(e) => {
                setValue(e.target.value);
                setPageId && setPageId(1);
                setSearch && setSearch(``);
              }}
              checked={value === ele?.value}
            />
            <span>
              {ele?.name}
              {ele?.length !== undefined && ` (${ele?.length})`}
            </span>
          </label>
        </>
      ))}
      {children}
    </>
  );
};

export const ButtonWithLoader = ({
  isLoading,
  onClick,
  disabled = false,
  children,
  className = "btn btn-primary",
  style,
  type = "button",
}) => {
  return (
    <button
      type={type}
      className={`${className} ${isLoading ? "disabled" : ""}`}
      onClick={onClick}
      disabled={disabled || isLoading}
      style={style ? style : {}}
    >
      {isLoading ? (
        <>
          {children}{" "}
          <span
            className="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
        </>
      ) : (
        children
      )}
    </button>
  );
};

export const PageLoader = () => {
  return (
    <div className="loader-container">
      <div className="loader">
        <div className="spinner-border" role="status"></div>
      </div>
    </div>
  );
};
